/* MOSHA - minimal interactions.
   Deliberately no cart/toast/sticky-ATC JS: add-to-cart posts to Shopify.

   Uses delegated listeners bound once on document, so it is safe if the file
   is included by more than one section, and it keeps working when the theme
   editor re-renders a section. */
(function () {
  if (window.__moshaInit) return;
  window.__moshaInit = true;

  document.addEventListener('click', function (e) {
    // FAQ accordions
    var q = e.target.closest('.mosha .qa .q');
    if (q) {
      var qa = q.closest('.qa');
      var open = qa.classList.toggle('open');
      q.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }

    // Mobile nav drawer (the approved UI hides .menu under 1020px with no
    // replacement, so this fills that gap using the same type styles)
    var b = e.target.closest('.mosha .burger');
    if (b) {
      var drawer = document.getElementById(b.getAttribute('aria-controls'));
      if (!drawer) return;
      var shown = drawer.classList.toggle('open');
      b.setAttribute('aria-expanded', shown ? 'true' : 'false');
      return;
    }

    // Header mega menu on desktop, the same trigger/panel classes reused as a
    // nested accordion in the mobile drawer. Click opens/closes; an outside
    // click or Escape below closes everything that is open.
    var trigger = e.target.closest('.dd-trigger, .m-dd-trigger');
    if (trigger) {
      var group = trigger.parentElement;
      var wasOpen = group.classList.contains('open');
      // opening a top-level dropdown closes any sibling one already open
      if (!wasOpen) {
        var scope = group.parentElement;
        scope.querySelectorAll(':scope > .has-dd.open, :scope > .m-dd.open').forEach(function (g) {
          if (g !== group) {
            g.classList.remove('open');
            var t = g.querySelector(':scope > .dd-trigger, :scope > .m-dd-trigger');
            if (t) t.setAttribute('aria-expanded', 'false');
          }
        });
      }
      group.classList.toggle('open', !wasOpen);
      trigger.setAttribute('aria-expanded', !wasOpen ? 'true' : 'false');
      if (!wasOpen) {
        var panel = group.querySelector(':scope > .dd-panel');
        if (panel) {
          panel.classList.remove('flip', 'flip-l');
          var r = panel.getBoundingClientRect();
          if (r.left < 16) panel.classList.add('flip-l');
          else if (r.right > window.innerWidth - 16) panel.classList.add('flip');
        }
      }
      return;
    }

    // any other click closes every open desktop dropdown (mobile accordion
    // items stay open until their own trigger or the drawer is closed)
    document.querySelectorAll('.has-dd.open').forEach(function (g) {
      g.classList.remove('open');
      var t = g.querySelector(':scope > .dd-trigger');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.has-dd.open').forEach(function (g) {
      g.classList.remove('open');
      var t = g.querySelector(':scope > .dd-trigger');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
  });
})();
